import axios from 'axios';
import React, { Fragment, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { IoMdArrowRoundBack } from "react-icons/io";

function BrandsListPage() {
    const [brandList, setBrandList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3500';

    // Shared tiny transparent gif fallback (consistent with categories) + dim effect
    const imgFallback = 'data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=';
    const handleImgError = (e) => {
        if (!e.currentTarget.dataset.fallback) {
            e.currentTarget.dataset.fallback = '1';
            e.currentTarget.src = imgFallback;
            e.currentTarget.style.opacity = '0.5';
        }
    };

    useEffect(() => {
        const fetchBrands = async () => {
            try {
                setError(null);
                const response = await axios.get(`${API_URL}/branddata`);
                setBrandList(response.data || []);
            } catch (err) {
                console.error("Error fetching brands:", err);
                setError('Failed to load brands');
            } finally {
                setLoading(false);
            }
        };
        fetchBrands();
    }, [API_URL]);

    return (
        <Fragment>
            <div className="container-fluid m-t25">
                {error && (
                    <div className="alert alert-warning small rounded-0 mt-2 mb-0" role="alert">{error}</div>
                )}
                <div className="row">
                    <div className="col-12 cat-strip border shadow-sm">
                        <div>
                            <button onClick={() => window.history.back()} aria-label="Go Back">
                                <IoMdArrowRoundBack />
                            </button>
                            <label>ALL BRANDS</label>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {loading ? (
                        <div className="loading-spinner">
                            <div className="spinner-border text-danger" role="status">
                                <span className="visually-hidden">Loading brands...</span>
                            </div>
                        </div>
                    ) : (
                        brandList.length > 0 ? (
                            brandList.map((item, index) => (
                                <div className="col-lg-3 col-md-3 col-sm-4 col-6 clist border text-center" key={item._id || index}>
                                    <Link
                                        to={`/products-by-brand/${item.name}`}
                                        className="d-block w-100"
                                        aria-label={`View brand ${item.name}`}
                                        title={item.name}
                                    >
                                        <img
                                            src={`${API_URL}/${item.image}`}
                                            className="img-fluid"
                                            alt={item.name}
                                            loading="lazy"
                                            onError={handleImgError}
                                        />
                                        <label>{item.name.toUpperCase()}</label>
                                    </Link>
                                </div>
                            ))
                        ) : (
                            <p className="text-center mb-0">No brands available.</p>
                        )
                    )}
                </div>
            </div>
        </Fragment>
    );
}

export default BrandsListPage;
